import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    returnItems: [],
};

const returnItemsManagementSlice = createSlice({
    name: 'return',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getReturnSuccess(state, action) {
            state.isLoading = false;
            state.returnItems = action.payload;
        },
    },
});

export default returnItemsManagementSlice.reducer;

export const { startLoading, hasError, getReturnSuccess } = returnItemsManagementSlice.actions;

export const getAllreturnItems = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('shipments/all-returned-items');
        dispatch(getReturnSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};
